import { RootState } from 'redux/store'

export const fleetErrorMessageSelector = (state: RootState) =>
  state.fleetReducer.errorMessage

export const pendingCarsCountSelector = (state: RootState) =>
  state.fleetReducer.pendingCarsCount
